var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-curvey"},[_c('h3',[_vm._v("Users Replied per Day")]),_c('apex-chart',{attrs:{"type":"line","options":_vm.options,"series":_vm.series,"height":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }